module.exports = __webpack_public_path__ + "img/consultas.03e0116f.jpeg";